export default [
  {
    path: '/gurudwara-onboard/list',
    name: 'gurudwara-onboard-list',
    component: () => import('@/views/gurudwara-onboard/index.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Gurudwara Onboard List',
      breadcrumb: [{ title: 'Dashboard', url: '/dashboard' }, { title: 'Gurudwara Onboard' }, { title: 'Gurudwara Onboard List', active: true }],
      permissions: ['gurudwara_onboard_list']
    }
  }
]
